export default {
  'photo-ver-title': 'Следуйте инструкциям',
  'photo-ver-text-1': 'Держите камеру на уровне глаз',
  'photo-ver-text-2': 'Убедитесь, что лицо освещено <br/> равномерно',
  'photo-ver-btn': 'Начать',
  'photo-ver-header-title': 'Подтвердите свою личность'
}